// https://reacttraining.com/react-router/web/guides/scroll-restoration

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.getElementById('root').scrollIntoView(true);
  }, [pathname]);

  return null;
}
